const AboutSection = () => {
  const team = [
    { name: 'Abhishek Pallati', role: 'Founder', image: 'https://ik.imagekit.io/p3xaqnkci/tagteam/team1.webp' },
    { name: 'Sandeep', role: 'Video Editor', image: 'assets/team2.png' },
    { name: 'Abhilash', role: 'Production Head', image: 'assets/team3.png' },
  ];

  return (
    <section id="about" className="bg-neutral-950 py-16 md:py-24 lg:py-40">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 md:gap-20 lg:gap-32">

          {/* Left Content */}
          <div>
            <span className="text-[#d4af37] text-xs md:text-sm tracking-[0.4em] block mb-3 md:mb-4">
              OUR STORY
            </span>

            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white font-serif font-light leading-tight">
              Crafting Timeless
              <span className="italic text-neutral-400 block">Memories</span>
            </h2>

            <div className="mt-6 md:mt-10 space-y-5 md:space-y-6 text-neutral-400 leading-relaxed text-sm md:text-base">
              <p>
                Born on December 28, 2015, TagTeam Studios emerged from a simple yet profound belief:
                every moment deserves to be immortalized with artistry and intention.
              </p>
              <p>
                Over nine transformative years, we've had the privilege of documenting over 250 weddings,
                countless celebrations, and intimate moments that define lives. We're not just photographers—we're
                visual storytellers, weaving emotions into every frame.
              </p>
            </div>

            {/* Stats */}
            <div className="mt-12 md:mt-16 grid grid-cols-3 gap-6 text-center lg:text-left">
              <div>
                <div className="text-4xl md:text-5xl font-serif text-[#d4af37]">10+</div>
                <div className="text-[0.65rem] md:text-xs tracking-[0.3em] text-neutral-500 mt-2">YEARS</div>
              </div>
              <div>
                <div className="text-4xl md:text-5xl font-serif text-[#d4af37]">250+</div>
                <div className="text-[0.65rem] md:text-xs tracking-[0.3em] text-neutral-500 mt-2">WEDDINGS</div>
              </div>
              <div>
                <div className="text-4xl md:text-5xl font-serif text-[#d4af37]">15+</div>
                <div className="text-[0.65rem] md:text-xs tracking-[0.3em] text-neutral-500 mt-2">AWARDS</div>
              </div>
            </div>
          </div>

          {/* Right – Team */}
          <div>
            <h3 className="text-lg sm:text-xl text-white tracking-[0.2em] font-light mb-6 md:mb-10 text-center lg:text-left">
              THE TEAM
            </h3>

            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 gap-6 md:gap-8">
              {team.map((member) => (
                <div key={member.name} className="cursor-hover group">
                  <div className="relative aspect-square overflow-hidden rounded-lg">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 grayscale group-hover:grayscale-0"
                    />
                    <div className="absolute inset-0 bg-[#d4af37]/0 group-hover:bg-[#d4af37]/10 transition-colors duration-500" />
                  </div>

                  <h4 className="text-white font-serif text-base sm:text-lg mt-3">
                    {member.name}
                  </h4>
                  <p className="text-neutral-500 text-xs sm:text-sm tracking-wider">{member.role}</p>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutSection;
